// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"fr","bottomColumnWapper":"fr","bottom-column-panel":"fs","bottomColumnPanel":"fs"};